import React, { useMemo } from 'react';

// --- IMPORTACIÓN DE NUESTRAS UTILIDADES DE SEGUROS ---
import { parseCurrency, formatCurrencyUniversal } from '../../../../utils/segurosUtils';

// --- ICONOS SVG ---
const IconShield = () => (
    <svg className="w-5 h-5 text-blue-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
);

const IconBuilding = () => (
    <svg className="w-5 h-5 text-indigo-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5m3 0h1m-1-4h.01M9 16h.01M15 16h.01M9 12h.01M15 12h.01M9 8h.01M15 8h.01" />
    </svg>
);

const ESTADOS_PENDIENTES = [
    'SIN ASIGNAR',
    'PENDIENTE',
    'INFORMADA',
    'RECLAMADA',
    'CBU READHERIDO',
    'TC READHERIDO'
];

const KpisCobranzas = ({ registros, isDbLoaded }) => {

    const financialMetrics = useMemo(() => {
        if (!isDbLoaded || !registros || registros.length === 0) {
            return {
                recaudado: { totalARS: 0, totalUSD: 0, totalCant: 0, cobrada: { ARS: 0, USD: 0, cant: 0 }, debitada: { ARS: 0, USD: 0, cant: 0 }, acreditada: { ARS: 0, USD: 0, cant: 0 } },
                cobradaAcreditada: { ARS: 0, USD: 0, cant: 0 },
                pendienteGeneral: { ARS: 0, USD: 0, cant: 0 },
                pendienteEstado: { ARS: 0, USD: 0, cant: 0 },
                incobrable: { ARS: 0, USD: 0, cant: 0 },
                reclamada: { ARS: 0, USD: 0, cant: 0 },
                informada: { ARS: 0, USD: 0, cant: 0 },
                adhesion: { ARS: 0, USD: 0, cant: 0 },
                anulada: { ARS: 0, USD: 0, cant: 0 },
                efectividadARS: 0,
                efectividadUSD: 0,
                porRiesgo: [],
                porCompania: []
            };
        }

        const cobrada = { ARS: 0, USD: 0, cant: 0 };
        const debitada = { ARS: 0, USD: 0, cant: 0 };
        const acreditada = { ARS: 0, USD: 0, cant: 0 };

        const pendienteGeneral = { ARS: 0, USD: 0, cant: 0 };
        const pendienteEstado = { ARS: 0, USD: 0, cant: 0 };
        const incobrable = { ARS: 0, USD: 0, cant: 0 };
        const reclamada = { ARS: 0, USD: 0, cant: 0 };
        const informada = { ARS: 0, USD: 0, cant: 0 };
        const adhesion = { ARS: 0, USD: 0, cant: 0 };
        const anulada = { ARS: 0, USD: 0, cant: 0 };

        let gestionadaARS = 0;
        let gestionadaUSD = 0;
        let gestionadaCant = 0;

        const riesgosMap = {};
        const companiasMap = {};

        const getOrCreateEntidad = (map, nombre) => {
            if (!map[nombre]) {
                map[nombre] = {
                    nombre,
                    // Conciliado
                    cantConciliada: 0,
                    conciliadoARS: 0,
                    conciliadoUSD: 0,
                    // Pendiente (No conciliado)
                    cantPendiente: 0,
                    pendienteARS: 0,
                    pendienteUSD: 0,
                    // Total general analizado
                    totalCant: 0
                };
            }
            return map[nombre];
        };

        registros.forEach(item => {
            const estado = String(item.estadoGestion || item.estado || '').trim().toUpperCase();
            const importe = parseCurrency(item.importe);
            const monedaRaw = String(item.moneda || item.monedaCobranza || item.monedaRefacturacion || '$').toUpperCase().trim();
            const esUSD = monedaRaw.includes('USD') || monedaRaw.includes('U$S') || monedaRaw.includes('DOLAR');

            // 1. Total Recaudado (COBRADA / DEBITADA / ACREDITADA)
            if (estado === 'COBRADA') {
                cobrada.cant += 1;
                if (esUSD) cobrada.USD += importe;
                else cobrada.ARS += importe;
            } else if (estado === 'DEBITADA') {
                debitada.cant += 1;
                if (esUSD) debitada.USD += importe;
                else debitada.ARS += importe;
            } else if (estado === 'ACREDITADA') {
                acreditada.cant += 1;
                if (esUSD) acreditada.USD += importe;
                else acreditada.ARS += importe;
            }

            // 2. Deuda Pendiente General
            if (ESTADOS_PENDIENTES.includes(estado)) {
                pendienteGeneral.cant += 1;
                if (esUSD) pendienteGeneral.USD += importe;
                else pendienteGeneral.ARS += importe;
            }

            // 3. Deuda Incobrable
            if (estado === 'INCOBRABLE') {
                incobrable.cant += 1;
                if (esUSD) incobrable.USD += importe;
                else incobrable.ARS += importe;
            }

            // 4. Cobranza Reclamada
            if (estado === 'RECLAMADA') {
                reclamada.cant += 1;
                if (esUSD) reclamada.USD += importe;
                else reclamada.ARS += importe;
            }

            // 5. Informada
            if (estado === 'INFORMADA') {
                informada.cant += 1;
                if (esUSD) informada.USD += importe;
                else informada.ARS += importe;
            }

            // 6. Cobranza en estado pendiente
            if (['PENDIENTE', 'SIN ASIGNAR'].includes(estado)) {
                pendienteEstado.cant += 1;
                if (esUSD) pendienteEstado.USD += importe;
                else pendienteEstado.ARS += importe;
            }

            // 7. Cobranza de Adhesión
            if (['CBU READHERIDO', 'TC READHERIDO'].includes(estado)) {
                adhesion.cant += 1;
                if (esUSD) adhesion.USD += importe;
                else adhesion.ARS += importe;
            }

            // 8. Cobranza Anulada
            if (estado === 'ANULADA') {
                anulada.cant += 1;
                if (esUSD) anulada.USD += importe;
                else anulada.ARS += importe;
            }

            // 9. Cobrada + Acreditada (Cobranza con gestión)
            if (['COBRADA', 'ACREDITADA'].includes(estado)) {
                gestionadaCant += 1;
                if (esUSD) gestionadaUSD += importe;
                else gestionadaARS += importe;
            }

            // 10. Procesamiento para Tablas de Riesgo y Compañía (Conciliadas vs. No Conciliadas)
            const esConciliada = ['COBRADA', 'DEBITADA', 'ACREDITADA'].includes(estado);
            const esPendiente = ESTADOS_PENDIENTES.includes(estado);

            if (esConciliada || esPendiente) {
                const riesgoNombre = item.riesgo || 'SIN ESPECIFICAR';
                const companiaNombre = item.compania || item.companiaExpirante || 'SIN ESPECIFICAR';

                const objRiesgo = getOrCreateEntidad(riesgosMap, riesgoNombre);
                const objCompania = getOrCreateEntidad(companiasMap, companiaNombre);

                objRiesgo.totalCant += 1;
                objCompania.totalCant += 1;

                if (esConciliada) {
                    objRiesgo.cantConciliada += 1;
                    objCompania.cantConciliada += 1;
                    if (esUSD) {
                        objRiesgo.conciliadoUSD += importe;
                        objCompania.conciliadoUSD += importe;
                    } else {
                        objRiesgo.conciliadoARS += importe;
                        objCompania.conciliadoARS += importe;
                    }
                } else if (esPendiente) {
                    objRiesgo.cantPendiente += 1;
                    objCompania.cantPendiente += 1;
                    if (esUSD) {
                        objRiesgo.pendienteUSD += importe;
                        objCompania.pendienteUSD += importe;
                    } else {
                        objRiesgo.pendienteARS += importe;
                        objCompania.pendienteARS += importe;
                    }
                }
            }
        });

        // Totales recaudados
        const totalARS = cobrada.ARS + debitada.ARS + acreditada.ARS;
        const totalUSD = cobrada.USD + debitada.USD + acreditada.USD;
        const totalCant = cobrada.cant + debitada.cant + acreditada.cant;

        // Efectividad (COBRADA + ACREDITADA) / (COBRADA + ACREDITADA + PENDIENTE GENERAL)
        const baseEfectividadARS = gestionadaARS + pendienteGeneral.ARS;
        const baseEfectividadUSD = gestionadaUSD + pendienteGeneral.USD;

        return {
            recaudado: { totalARS, totalUSD, totalCant, cobrada, debitada, acreditada },
            cobradaAcreditada: { ARS: gestionadaARS, USD: gestionadaUSD, cant: gestionadaCant },
            pendienteGeneral,
            pendienteEstado,
            incobrable,
            reclamada,
            informada,
            adhesion,
            anulada,
            efectividadARS: baseEfectividadARS > 0 ? (gestionadaARS / baseEfectividadARS) * 100 : 0,
            efectividadUSD: baseEfectividadUSD > 0 ? (gestionadaUSD / baseEfectividadUSD) * 100 : 0,
            porRiesgo: Object.values(riesgosMap).sort((a, b) => b.totalCant - a.totalCant),
            porCompania: Object.values(companiasMap).sort((a, b) => b.totalCant - a.totalCant)
        };
    }, [registros, isDbLoaded]);

    if (!isDbLoaded) {
        return (
            <div className="p-8 text-center text-slate-400 italic text-sm select-none">
                Cargando análisis de cobranzas y arqueo...
            </div>
        );
    }

    if (registros.length === 0) {
        return (
            <div className="p-12 text-center text-slate-400 italic text-sm bg-white rounded-3xl border border-slate-200">
                No hay transacciones de cobranza cargadas en este rango para procesar KPIs.
            </div>
        );
    }

    return (
        <div className="space-y-8 text-left animate-fade-in">
            
            {/* LÍNEA 1: CARDS PRINCIPALES */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                
                {/* 1. TOTAL RECAUDADO */}
                <div className="bg-white p-4 border border-slate-200 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md">
                    <div>
                        <div className="flex justify-between items-center">
                            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest leading-none">Total Recaudado</p>
                            <span className="text-[9px] font-mono font-bold bg-emerald-50 text-emerald-700 px-1.5 py-0.5 rounded border border-emerald-100">
                                {financialMetrics.recaudado.totalCant} cuotas
                            </span>
                        </div>
                        <h4 className="text-xl font-black text-emerald-600 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.recaudado.totalARS, '$')}
                        </h4>
                        {financialMetrics.recaudado.totalUSD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.recaudado.totalUSD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    
                    {/* DESGLOSE: COBRADA / DEBITADA / ACREDITADA */}
                    <div className="mt-3 pt-2 border-t border-slate-100 text-[11px] font-bold uppercase space-y-1">
                        <div className="flex justify-between items-center text-slate-600">
                            <span>Cobrada ({financialMetrics.recaudado.cobrada.cant}):</span>
                            <span className="font-mono font-black text-slate-800">
                                {formatCurrencyUniversal(financialMetrics.recaudado.cobrada.ARS, '$')}
                                {financialMetrics.recaudado.cobrada.USD > 0 && ` | ${formatCurrencyUniversal(financialMetrics.recaudado.cobrada.USD, 'U$S')}`}
                            </span>
                        </div>
                        <div className="flex justify-between items-center text-slate-600">
                            <span>Debitada ({financialMetrics.recaudado.debitada.cant}):</span>
                            <span className="font-mono font-black text-slate-800">
                                {formatCurrencyUniversal(financialMetrics.recaudado.debitada.ARS, '$')}
                                {financialMetrics.recaudado.debitada.USD > 0 && ` | ${formatCurrencyUniversal(financialMetrics.recaudado.debitada.USD, 'U$S')}`}
                            </span>
                        </div>
                        <div className="flex justify-between items-center text-slate-600">
                            <span>Acreditada ({financialMetrics.recaudado.acreditada.cant}):</span>
                            <span className="font-mono font-black text-slate-800">
                                {formatCurrencyUniversal(financialMetrics.recaudado.acreditada.ARS, '$')}
                                {financialMetrics.recaudado.acreditada.USD > 0 && ` | ${formatCurrencyUniversal(financialMetrics.recaudado.acreditada.USD, 'U$S')}`}
                            </span>
                        </div>
                    </div>
                </div>

                {/* 2. DEUDA PENDIENTE GENERAL */}
                <div className="bg-white p-4 border border-rose-200 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-rose-50/10">
                    <div>
                        <div className="flex justify-between items-center">
                            <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest leading-none">Deuda Pendiente</p>
                            <span className="text-[9px] font-mono font-bold bg-rose-50 text-rose-700 px-1.5 py-0.5 rounded border border-rose-200">
                                {financialMetrics.pendienteGeneral.cant} cuotas
                            </span>
                        </div>
                        <h4 className="text-xl font-black text-rose-600 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.pendienteGeneral.ARS, '$')}
                        </h4>
                        {financialMetrics.pendienteGeneral.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.pendienteGeneral.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <p className="text-[9px] text-rose-500 mt-2 font-bold uppercase tracking-wider">Total saldos pendientes de cobro</p>
                </div>

                {/* 3. DEUDA INCOBRABLE */}
                <div className="bg-white p-4 border border-amber-200 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-amber-50/10">
                    <div>
                        <div className="flex justify-between items-center">
                            <p className="text-[10px] font-black text-amber-600 uppercase tracking-widest leading-none">Deuda Incobrable</p>
                            <span className="text-[9px] font-mono font-bold bg-amber-50 text-amber-700 px-1.5 py-0.5 rounded border border-amber-200">
                                {financialMetrics.incobrable.cant} cuotas
                            </span>
                        </div>
                        <h4 className="text-xl font-black text-amber-600 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.incobrable.ARS, '$')}
                        </h4>
                        {financialMetrics.incobrable.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.incobrable.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <p className="text-[9px] text-amber-600 mt-2 font-bold uppercase tracking-wider">Pérdida técnica / incobrable</p>
                </div>

                {/* 4. EFECTIVIDAD DE COBRO */}
                <div className="bg-white p-4 border border-slate-200 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md">
                    <div>
                        <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest leading-none">Efectividad de Cobro</p>
                        <h4 className="text-xl font-black text-[#01032d] mt-2 font-mono tracking-tight">
                            {financialMetrics.efectividadARS.toFixed(1)}% <span className="text-[10px] text-slate-400 font-bold uppercase">ARS</span>
                        </h4>
                        {financialMetrics.efectividadUSD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {financialMetrics.efectividadUSD.toFixed(1)}% <span className="text-[9px] text-slate-400 font-bold uppercase">USD</span>
                            </h5>
                        )}
                    </div>
                    <p className="text-[9px] text-slate-400 mt-2 font-bold uppercase tracking-wider">Cobrado con gestión (Excluye Débitos)</p>
                </div>

            </div>

            {/* LÍNEA 2: KPIS DE GESTIÓN Y ESTADOS OPERATIVOS */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                
                {/* 1. COBRADA + ACREDITADA */}
                <div className="bg-white p-4 border border-emerald-100 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-emerald-50/20">
                    <div>
                        <div className="flex items-center justify-between">
                            <p className="text-[10px] font-black text-emerald-700 uppercase tracking-widest leading-none">Cobrada + Acreditada</p>
                            <span className="text-[11px] font-mono font-bold bg-emerald-100 text-emerald-800 px-1.5 py-0.5 rounded">
                                {financialMetrics.cobradaAcreditada.cant} cuotas
                            </span>
                        </div>
                        <h4 className="text-lg font-black text-emerald-700 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.cobradaAcreditada.ARS, '$')}
                        </h4>
                        {financialMetrics.cobradaAcreditada.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.cobradaAcreditada.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <span className="text-[11px] font-bold text-emerald-600 uppercase tracking-wider mt-2">Cobranza con gestión</span>
                </div>

                {/* 2. COBRANZA RECLAMADA */}
                <div className="bg-white p-4 border border-slate-200 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-slate-50/30">
                    <div>
                        <div className="flex items-center justify-between">
                            <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest leading-none">Cobranza Reclamada</p>
                            <span className="text-[11px] font-mono font-bold bg-slate-200 text-slate-700 px-1.5 py-0.5 rounded">
                                {financialMetrics.reclamada.cant} casos
                            </span>
                        </div>
                        <h4 className="text-lg font-black text-slate-800 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.reclamada.ARS, '$')}
                        </h4>
                        {financialMetrics.reclamada.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.reclamada.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mt-2">Estado: RECLAMADA</span>
                </div>

                {/* 3. INFORMADA */}
                <div className="bg-white p-4 border border-slate-200 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-slate-50/30">
                    <div>
                        <div className="flex items-center justify-between">
                            <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest leading-none">Informada</p>
                            <span className="text-[11px] font-mono font-bold bg-slate-200 text-slate-700 px-1.5 py-0.5 rounded">
                                {financialMetrics.informada.cant} casos
                            </span>
                        </div>
                        <h4 className="text-lg font-black text-slate-800 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.informada.ARS, '$')}
                        </h4>
                        {financialMetrics.informada.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.informada.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wider mt-2">Estado: INFORMADA</span>
                </div>

                {/* 4. COBRANZA DE ADHESIÓN */}
                <div className="bg-white p-4 border border-indigo-100 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-indigo-50/20">
                    <div>
                        <div className="flex items-center justify-between">
                            <p className="text-[10px] font-black text-indigo-600 uppercase tracking-widest leading-none">Cobranza Adhesión</p>
                            <span className="text-[11px] font-mono font-bold bg-indigo-100 text-indigo-700 px-1.5 py-0.5 rounded">
                                {financialMetrics.adhesion.cant} casos
                            </span>
                        </div>
                        <h4 className="text-lg font-black text-indigo-700 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.adhesion.ARS, '$')}
                        </h4>
                        {financialMetrics.adhesion.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.adhesion.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <span className="text-[9px] font-bold text-indigo-500 uppercase tracking-wider mt-2">CBU / TC READHERIDO</span>
                </div>

                {/* 5. COBRANZA EN ESTADO PENDIENTE */}
                <div className="bg-white p-4 border border-amber-100 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-amber-50/20">
                    <div>
                        <div className="flex items-center justify-between">
                            <p className="text-[10px] font-black text-amber-700 uppercase tracking-widest leading-none">Estado Pendiente</p>
                            <span className="text-[11px] font-mono font-bold bg-amber-100 text-amber-800 px-1.5 py-0.5 rounded">
                                {financialMetrics.pendienteEstado.cant} casos
                            </span>
                        </div>
                        <h4 className="text-lg font-black text-amber-700 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.pendienteEstado.ARS, '$')}
                        </h4>
                        {financialMetrics.pendienteEstado.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.pendienteEstado.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <span className="text-[9px] font-bold text-amber-600 uppercase tracking-wider mt-2">PENDIENTE / SIN ASIGNAR</span>
                </div>

                {/* 6. COBRANZA ANULADA */}
                <div className="bg-white p-4 border border-rose-100 rounded-2xl shadow-sm flex flex-col justify-between transition-all hover:shadow-md bg-rose-50/20">
                    <div>
                        <div className="flex items-center justify-between">
                            <p className="text-[10px] font-black text-rose-600 uppercase tracking-widest leading-none">Cobranza Anulada</p>
                            <span className="text-[11px] font-mono font-bold bg-rose-100 text-rose-700 px-1.5 py-0.5 rounded">
                                {financialMetrics.anulada.cant} casos
                            </span>
                        </div>
                        <h4 className="text-lg font-black text-rose-700 mt-2 font-mono tracking-tight">
                            {formatCurrencyUniversal(financialMetrics.anulada.ARS, '$')}
                        </h4>
                        {financialMetrics.anulada.USD > 0 && (
                            <h5 className="text-xs font-black text-blue-600 mt-0.5 font-mono">
                                {formatCurrencyUniversal(financialMetrics.anulada.USD, 'U$S')}
                            </h5>
                        )}
                    </div>
                    <span className="text-[9px] font-bold text-rose-500 uppercase tracking-wider mt-2">Estado: ANULADA</span>
                </div>

            </div>

            {/* LÍNEA 3: TABLAS COMPARATIVAS (CONCILIADO VS. NO CONCILIADO) */}
            <div className="space-y-8 w-full">
                
                {/* TABLA A: CUOTAS POR RIESGO (CONCILIADO VS NO CONCILIADO) */}
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden text-left flex flex-col w-full">
                    <div className="p-4 px-6 bg-slate-50 border-b font-black text-[11px] text-slate-500 uppercase tracking-wider flex items-center justify-between select-none">
                        <div className="flex items-center gap-2.5">
                            <div className="bg-blue-50 p-1.5 rounded-lg text-blue-600">
                                <IconShield />
                            </div>
                            <div>
                                <span className="block font-black text-slate-800 leading-none">Arqueo por Ramo / Riesgo</span>
                                <span className="text-[9px] text-slate-400 font-bold uppercase tracking-wider mt-1 block">Comparativa de recaudación efectiva vs. saldo no conciliado (pendiente)</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="overflow-x-auto w-full custom-scrollbar">
                        <table className="w-full text-xs border-collapse min-w-[850px]">
                            <thead className="bg-slate-50/70 text-slate-500 border-b uppercase text-[9px] font-black tracking-wider select-none">
                                <tr>
                                    <th rowSpan="2" className="p-3 pl-6 text-left border-r border-slate-200/60 align-middle">
                                        Riesgo / Rama
                                    </th>
                                    <th colSpan="3" className="p-2 text-center bg-emerald-50/50 text-emerald-800 border-r border-slate-200/60">
                                        Conciliado (Cobrado / Débito)
                                    </th>
                                    <th colSpan="3" className="p-2 text-center bg-rose-50/50 text-rose-800 border-r border-slate-200/60">
                                        No Conciliado (Pendiente)
                                    </th>
                                    <th rowSpan="2" className="p-3 text-center align-middle pr-6">
                                        Total Casos
                                    </th>
                                </tr>
                                <tr className="border-t border-slate-200/60 text-[8px]">
                                    <th className="p-2 text-center bg-emerald-50/30 text-emerald-700">Cuotas</th>
                                    <th className="p-2 text-right bg-emerald-50/30 text-emerald-700">Monto ARS</th>
                                    <th className="p-2 text-right bg-emerald-50/30 text-emerald-700 border-r border-slate-200/60">Monto USD</th>
                                    <th className="p-2 text-center bg-rose-50/30 text-rose-700">Cuotas</th>
                                    <th className="p-2 text-right bg-rose-50/30 text-rose-700">Monto ARS</th>
                                    <th className="p-2 text-right bg-rose-50/30 text-rose-700 border-r border-slate-200/60">Monto USD</th>
                                </tr>
                            </thead>
                            <tbody className="font-semibold text-slate-700 divide-y divide-slate-100 bg-white">
                                {financialMetrics.porRiesgo.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="p-8 text-center text-slate-400 italic">
                                            Sin registros de cobranza por riesgo en este período.
                                        </td>
                                    </tr>
                                ) : (
                                    financialMetrics.porRiesgo.map(r => (
                                        <tr key={r.nombre} className="hover:bg-slate-50/40 transition-colors">
                                            <td className="p-3 pl-6 text-slate-900 font-black uppercase text-xs border-r border-slate-100">
                                                {r.nombre}
                                            </td>
                                            
                                            {/* CONCILIADO */}
                                            <td className="p-3 text-center bg-emerald-50/10">
                                                <span className="bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5 rounded-full text-[10px] font-bold">
                                                    {r.cantConciliada}
                                                </span>
                                            </td>
                                            <td className="p-3 text-right font-mono text-emerald-600 text-xs font-black bg-emerald-50/10">
                                                {r.conciliadoARS > 0 ? formatCurrencyUniversal(r.conciliadoARS, '$') : '-'}
                                            </td>
                                            <td className="p-3 text-right font-mono text-blue-600 text-xs font-black border-r border-slate-100 bg-emerald-50/10">
                                                {r.conciliadoUSD > 0 ? formatCurrencyUniversal(r.conciliadoUSD, 'U$S') : '-'}
                                            </td>

                                            {/* NO CONCILIADO / PENDIENTE */}
                                            <td className="p-3 text-center bg-rose-50/10">
                                                <span className="bg-rose-50 border border-rose-200 text-rose-700 px-2 py-0.5 rounded-full text-[10px] font-bold">
                                                    {r.cantPendiente}
                                                </span>
                                            </td>
                                            <td className="p-3 text-right font-mono text-rose-600 text-xs font-black bg-rose-50/10">
                                                {r.pendienteARS > 0 ? formatCurrencyUniversal(r.pendienteARS, '$') : '-'}
                                            </td>
                                            <td className="p-3 text-right font-mono text-blue-600 text-xs font-black border-r border-slate-100 bg-rose-50/10">
                                                {r.pendienteUSD > 0 ? formatCurrencyUniversal(r.pendienteUSD, 'U$S') : '-'}
                                            </td>

                                            {/* TOTAL */}
                                            <td className="p-3 text-center font-mono font-bold text-slate-700 pr-6">
                                                {r.totalCant}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* TABLA B: CUOTAS POR COMPAÑÍA (CONCILIADO VS NO CONCILIADO) */}
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden text-left flex flex-col w-full">
                    <div className="p-4 px-6 bg-slate-50 border-b font-black text-[11px] text-slate-500 uppercase tracking-wider flex items-center justify-between select-none">
                        <div className="flex items-center gap-2.5">
                            <div className="bg-indigo-50 p-1.5 rounded-lg text-indigo-600">
                                <IconBuilding />
                            </div>
                            <div>
                                <span className="block font-black text-slate-800 leading-none">Arqueo por Compañía Aseguradora</span>
                                <span className="text-[9px] text-slate-400 font-bold uppercase tracking-wider mt-1 block">Comparativa de recaudación efectiva vs. saldo no conciliado (pendiente)</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="overflow-x-auto w-full custom-scrollbar">
                        <table className="w-full text-xs border-collapse min-w-[850px]">
                            <thead className="bg-slate-50/70 text-slate-500 border-b uppercase text-[9px] font-black tracking-wider select-none">
                                <tr>
                                    <th rowSpan="2" className="p-3 pl-6 text-left border-r border-slate-200/60 align-middle">
                                        Compañía
                                    </th>
                                    <th colSpan="3" className="p-2 text-center bg-emerald-50/50 text-emerald-800 border-r border-slate-200/60">
                                        Conciliado (Cobrado / Débito)
                                    </th>
                                    <th colSpan="3" className="p-2 text-center bg-rose-50/50 text-rose-800 border-r border-slate-200/60">
                                        No Conciliado (Pendiente)
                                    </th>
                                    <th rowSpan="2" className="p-3 text-center align-middle pr-6">
                                        Total Casos
                                    </th>
                                </tr>
                                <tr className="border-t border-slate-200/60 text-[8px]">
                                    <th className="p-2 text-center bg-emerald-50/30 text-emerald-700">Cuotas</th>
                                    <th className="p-2 text-right bg-emerald-50/30 text-emerald-700">Monto ARS</th>
                                    <th className="p-2 text-right bg-emerald-50/30 text-emerald-700 border-r border-slate-200/60">Monto USD</th>
                                    <th className="p-2 text-center bg-rose-50/30 text-rose-700">Cuotas</th>
                                    <th className="p-2 text-right bg-rose-50/30 text-rose-700">Monto ARS</th>
                                    <th className="p-2 text-right bg-rose-50/30 text-rose-700 border-r border-slate-200/60">Monto USD</th>
                                </tr>
                            </thead>
                            <tbody className="font-semibold text-slate-700 divide-y divide-slate-100 bg-white">
                                {financialMetrics.porCompania.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="p-8 text-center text-slate-400 italic">
                                            Sin registros de cobranza por compañía en este período.
                                        </td>
                                    </tr>
                                ) : (
                                    financialMetrics.porCompania.map(c => (
                                        <tr key={c.nombre} className="hover:bg-slate-50/40 transition-colors">
                                            <td className="p-3 pl-6 text-slate-900 font-black uppercase text-xs border-r border-slate-100">
                                                {c.nombre}
                                            </td>

                                            {/* CONCILIADO */}
                                            <td className="p-3 text-center bg-emerald-50/10">
                                                <span className="bg-emerald-50 border border-emerald-200 text-emerald-700 px-2 py-0.5 rounded-full text-[10px] font-bold">
                                                    {c.cantConciliada}
                                                </span>
                                            </td>
                                            <td className="p-3 text-right font-mono text-emerald-600 text-xs font-black bg-emerald-50/10">
                                                {c.conciliadoARS > 0 ? formatCurrencyUniversal(c.conciliadoARS, '$') : '-'}
                                            </td>
                                            <td className="p-3 text-right font-mono text-blue-600 text-xs font-black border-r border-slate-100 bg-emerald-50/10">
                                                {c.conciliadoUSD > 0 ? formatCurrencyUniversal(c.conciliadoUSD, 'U$S') : '-'}
                                            </td>

                                            {/* NO CONCILIADO / PENDIENTE */}
                                            <td className="p-3 text-center bg-rose-50/10">
                                                <span className="bg-rose-50 border border-rose-200 text-rose-700 px-2 py-0.5 rounded-full text-[10px] font-bold">
                                                    {c.cantPendiente}
                                                </span>
                                            </td>
                                            <td className="p-3 text-right font-mono text-rose-600 text-xs font-black bg-rose-50/10">
                                                {c.pendienteARS > 0 ? formatCurrencyUniversal(c.pendienteARS, '$') : '-'}
                                            </td>
                                            <td className="p-3 text-right font-mono text-blue-600 text-xs font-black border-r border-slate-100 bg-rose-50/10">
                                                {c.pendienteUSD > 0 ? formatCurrencyUniversal(c.pendienteUSD, 'U$S') : '-'}
                                            </td>

                                            {/* TOTAL */}
                                            <td className="p-3 text-center font-mono font-bold text-slate-700 pr-6">
                                                {c.totalCant}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <style>{`
                .custom-scrollbar::-webkit-scrollbar { width: 5px; height: 5px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
                .animate-fade-in { animation: fadeIn 0.25s ease-out forwards; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
};

export default KpisCobranzas;